import React, { useRef, useState, useEffect } from "react";
import Chatroom from "../chatroom";
import Chatfooter from "../chatfooter";
import ChatBotHeader from "./Header";
import {
  serverTimestamp,
  setDoc,
  getDoc,
  doc,
} from "firebase/firestore";
import "./chatbot.css";
import { db } from "../../config/firebase";

function ChatBot(props) {
  const [newMessages, setNewMessage] = useState([]);
  const [startNewChat, setStartNewChat] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const chatRoomRef = useRef(null);
  const refreshHandlerRef = useRef(null);

  // ✅ Derive showExtraContent from float_visible prop
  const showExtraContent = !props.float_visible;

  // ✅ Toggle and always notify parent on close
  const toggleExtraContent = () => {
    const newValue = !props.float_visible;
    props.setfloat_Visible(newValue);

    if (!newValue) {
      window.parent.postMessage({ action: 'close_chat' }, '*');
    }
  };

  const handleRefreshFromHeader = () => {
    if (refreshHandlerRef.current) {
      refreshHandlerRef.current();
    }
  };

  const setRefreshHandler = (handler) => {
    refreshHandlerRef.current = handler;
  };

  const setCookie = (name, value, days = 30) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
};

const getCookie = (name) => {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return match ? decodeURIComponent(match.split("=")[1]) : null;
};
  function getCurrentISTDate() {
    const date = new Date();
    const utcOffset = date.getTimezoneOffset();
    const istOffset = 330;
    const istDate = new Date(date.getTime() + (istOffset + utcOffset) * 60000);
    const year = istDate.getFullYear();
    const month = String(istDate.getMonth() + 1).padStart(2, '0');
    const day = String(istDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  const exportMessages = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);

      if (!storedData) {
        alert("No messages found to export.");
        return;
      }

      const parsedData = JSON.parse(storedData);
      const docid = parsedData.key;

      const docRef = doc(db, "Messages", docid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const messages = data.Messages || [];

        const userMessages = messages.filter(msg =>
          msg.user && !msg.server ||
          (msg.hasOwnProperty('user') && !msg.hasOwnProperty('server'))
        );

        if (userMessages.length === 0) {
          alert("No user messages found to export.");
          return;
        }

        const exportData = {
          exportDate: new Date().toISOString(),
          totalUserMessages: userMessages.length,
          userMessages: userMessages.map((msg, index) => ({
            messageNumber: index + 1,
            content: msg.user || msg.message || msg.text
          }))
        };

        const dataStr = JSON.stringify(exportData, null, 2);
        const dataBlob = new Blob([dataStr], { type: 'application/json' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(dataBlob);
        link.download = `user_messages_${getCurrentISTDate()}.json`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

      } else {
        alert("No conversation data found.");
      }
    } catch (error) {
      console.error("Error exporting messages:", error);
      alert("Failed to export messages. Please try again.");
    }
  };

  const saveActionToFirestore = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const currentDomain = urlParams.get("parentUrl");
      const shopId = currentDomain || "null";

      const uidvar = currentDomain + "uid";
      let uid = getCookie(uidvar) || "";

      const currentTime = new Date();
      const seconds = currentTime.getSeconds();
      const month = String(currentTime.getMonth() + 1).padStart(2, "0");
      const day = String(currentTime.getDate()).padStart(2, "0");
      const year = currentTime.getFullYear();
      const formattedHours = String(currentTime.getHours() % 12 || 12).padStart(2, "0");
      const formattedMinutes = String(currentTime.getMinutes()).padStart(2, "0");
      const date_string = `${month}/${day}/${year}, ${formattedHours}:${formattedMinutes}:${seconds}`;

      const data_var = currentDomain + "myData";
      const storedData = getCookie(data_var);
      let docid = "";

      if (!storedData) {
        const initialData = { key: uid + Date.now().toString() };
        setCookie(data_var, JSON.stringify(initialData));
        docid = initialData.key;
        const docRef = doc(db, "Messages", docid);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          await setDoc(docRef, {
            Chat_Status: "Open",
            Fetch_Firestore: true,
            Messages: [{ server: "Hello, how can I help you?", server_timestamp: date_string }],
            server: false,
            user_id: uid,
            shop_id: shopId,
            User_Channel: "Web",
            timestamp: Date.now(),
            ticket_id: docid,
            assigned_to: "bot@krunk.ai",
            doc_id: docid,
            User_Timestamp: getCurrentISTDate(),
            created_at: serverTimestamp(),
            last_updated: serverTimestamp(),
          }, { merge: true });
        }
      } else {
        const parsedData = JSON.parse(storedData);
        docid = parsedData.key;
      }
    } catch (error) {
      console.error("Error saving action to Firestore:", error);
    }
  };

  useEffect(() => {
    saveActionToFirestore();
  }, []);

return (
  <div style={{ height: '100dvh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

    {!showExtraContent && (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          maxWidth: window.innerWidth < 640 ? '100%' : '420px',
          overflow: 'hidden',
          boxShadow: '3px 3px 5px 0 rgba(0, 0, 0, 0.3)',
          margin: window.innerWidth < 640 ? '0' : '0 0 0 auto',
        }}
        className="krunk-border krunk-border-gray-100 krunk-bg-white krunk-bg-headercolor sm:krunk-rounded-xl"
      >
        {/* Header - never shrinks */}
        <div style={{ flexShrink: 0 }}>
          <ChatBotHeader
            title={props.title}
            imageurl={props.imageurl}
            showExtraContent={showExtraContent}
            toggleExtraContent={toggleExtraContent}
            onRefresh={handleRefreshFromHeader}
          />
        </div>

        {/* Scrollable chat area - takes remaining space */}
        <div
          ref={chatRoomRef}
          style={{
            flex: 1,
            minHeight: 0,        /* ← critical, allows shrinking */
            overflow: 'hidden',
            position: 'relative',
          }}
          className="krunk-border-2 krunk-border-gray-50"
        >
          <Chatroom
            sharedData={newMessages}
            userId={props.userId}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            actionButtons={props.actionButtons}
            subMenu={props.subMenu}
            onRefreshHandler={setRefreshHandler}
          />
        </div>

        {/* Footer - never shrinks */}
        <div style={{ flexShrink: 0 }}>
          <Chatfooter
            messageupdate={setNewMessage}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            setStartNewChat={setStartNewChat}
            startNewChat={startNewChat}
          />
        </div>
      </div>
    )}

    {/* Export Button */}
    {!showExtraContent && (
      <button
        onClick={exportMessages}
        className="krunk-fixed krunk-bottom-4 krunk-left-4 krunk-bg-blue-600 hover:krunk-bg-blue-700 krunk-text-white krunk-px-4 krunk-py-2 krunk-rounded-lg krunk-shadow-lg krunk-items-center krunk-gap-2 krunk-transition-all krunk-duration-300 krunk-z-50 krunk-hidden lg:krunk-flex"
        aria-label="Export user messages"
        title="Export user messages to file"
      >
        <svg className="krunk-w-4 krunk-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <span className="krunk-text-sm krunk-font-medium">Export</span>
      </button>
    )}
  </div>
);

}

export default ChatBot;